export { default as ProductsElasticSearchCategoriesNavAmountButton } from './ProductsElasticSearchCategoriesNavAmountButton';
